import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'json-edit',
  styleUrls: ['./json-edit.component.less'],
  templateUrl: './json-edit.component.html',
})
export class JsonEditComponent implements OnInit {
  @Input() data: any;
  @Output() dataChange = new EventEmitter<{ error: boolean, data: any }>();

  public error?: string;
  public jsonDataControl: FormControl<any>;
  public dataUrlGenerated: boolean = false;

  public ngOnInit() {
    this.jsonDataControl = new FormControl(this.stringifyJson(this.data));
    this.jsonDataControl.valueChanges.subscribe(value => {
      this.validateJson(value);
    });
  }

  public validateJson(value: string) {
    try {
      const jsonData = JSON.parse(value);
      this.error = undefined;
      this.dataChange.emit({ error: false, data: jsonData });
    } catch (e) {
      this.error = e.message || e.toString();
      this.dataChange.emit({ error: true, data: null });
    }
  }

  public dataUrl() {
    const url = `${window.location.protocol}//${window.location.hostname}/new?data=${btoa(JSON.stringify(this.data))}`;
    const copyInput = document.createElement('input');
    copyInput.value = url;
    document.body.appendChild(copyInput);
    copyInput.focus();
    copyInput.select();
    try {
      const success = document.execCommand('copy');
      if (success) {
        this.dataUrlGenerated = true;
      }
    } catch (err) {
    }
    document.body.removeChild(copyInput);
  }

  private stringifyJson(value: any): string {
    return JSON.stringify(value, null, 2);
  }
}
